import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const Token = 'Token'
const Refresh_token = 'Refresh_token'

export function getToken() {
  return localStorage.getItem(Token)
}
export function getOrgId() {
      return localStorage.getItem("stationId")
}
export function getadminToken() {
  return Cookies.get(Token)
}
export function getRefresh_token() {
  return Cookies.get(Refresh_token)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function setRefresh_token(token) {
  return Cookies.set(Refresh_token, token)
}
export function setadminToken(token) {
  return Cookies.set(Token, token)
}

export function removeadminToken() {
  return Cookies.remove(Token)
}
export function removeRefresh_token() {
  return Cookies.remove(Refresh_token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
